// Udvid kun klik-funktionalitet hvis Impact-temaet ikke allerede håndterer det
(function() {
  var menus = document.querySelectorAll('.mega-menu');
  menus.forEach(function(menu) {
    var lis = menu.querySelectorAll('.mega-first > li');
    lis.forEach(function(li) {
      var toggle = li.querySelector('.js-mega-toggle');
      if (!toggle) return;
      // Undgå dobbeltbinding hvis Impact allerede har event
      if (toggle.dataset.megaClickBound) return;
      toggle.dataset.megaClickBound = 'true';
      toggle.addEventListener('click', function(e) {
        if (li.classList.contains('open')) {
          li.classList.remove('open');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          lis.forEach(function(otherLi) {
            if (otherLi !== li) {
              otherLi.classList.remove('open');
              var otherToggle = otherLi.querySelector('.js-mega-toggle');
              if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
            }
          });
          li.classList.add('open');
          toggle.setAttribute('aria-expanded', 'true');
        }
        e.preventDefault();
      });
    });
    document.addEventListener('click', function(e) {
      if (!menu.contains(e.target)) {
        lis.forEach(function(openLi) {
          if (openLi.classList.contains('open')) {
            openLi.classList.remove('open');
            var toggle = openLi.querySelector('.js-mega-toggle');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });
  });
})();
